module.exports = __webpack_public_path__ + "Roboto-Medium.2741a14e49524efa6059.woff2";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Medium.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Medium.woff2
// module chunks = 13